let logger = console;
const setLogger = (analyticsLogger) => {
  logger = initLogger(analyticsLogger);
};
const baseFields = {
  team: "CXT",
  library: "Event-Horizon"
};
const addPrefix = (msg) => `[CXT][Event-Horizon] ${msg}`;
const initLogger = (parentLogger) => ({
  debug: (msg, extra = {}) => parentLogger.debug(addPrefix(msg), { ...extra, ...baseFields }),
  info: (msg, extra = {}) => parentLogger.info(addPrefix(msg), { ...extra, ...baseFields }),
  warn: (msg, extra = {}) => parentLogger.warn(addPrefix(msg), { ...extra, ...baseFields }),
  error: (msg, extra = {}) => parentLogger.error(addPrefix(msg), { ...extra, ...baseFields })
});
export {
  initLogger,
  logger,
  setLogger
};
